import { AxiosPromise } from 'axios';
import { IResetPasswordCommand } from './types';
import { instance } from '../../services/api';

export default (data: IResetPasswordCommand): AxiosPromise =>
  instance.post(`api/accounts/reset`, data);
